// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__mvRd8","tooltip":"Tooltip_tooltip__D3VCJ","isVisible":"Tooltip_isVisible__49XVr","fullWidth":"Tooltip_fullWidth__c4CIe"};